
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Erdogan',
      restaurant: 'Snack Istanbul',
      quote: 'Grâce à VirtualEat, +37% de ventes en 2 mois ! Je ne pensais pas que c\'était possible sans investir. Maintenant j\'ai 3 marques qui marchent super bien.',
      rating: 5,
      stats: '+220 commandes supplémentaires par mois',
      revenue: '+1,450€/mois'
    },
    {
      name: 'Sofia',
      restaurant: 'Pizza Time',
      quote: 'Sans rien investir… VirtualEat l\'a fait ! Mes nouvelles marques virtuelles génèrent 800€ de plus par mois. L\'équipe gère tout, je me concentre sur la cuisine.',
      rating: 4.5,
      stats: '+180 commandes supplémentaires par mois',
      revenue: '+800€/mois'
    },
    {
      name: 'Ahmed',
      restaurant: 'Le Comptoir Oriental',
      quote: 'En 6 semaines, mes commandes ont doublé ! VirtualEat a créé 2 concepts parfaits pour ma cuisine. Le service client est exceptionnel.',
      rating: 5,
      stats: '+95% d\'augmentation des commandes',
      revenue: '+1,200€/mois'
    },
    {
      name: 'Marie',
      restaurant: 'Chez Marie',
      quote: 'J\'étais sceptique au début, mais VirtualEat a transformé mon business. 3 nouvelles marques créées et mes ventes ont explosé !',
      rating: 4,
      stats: '+42% de ventes en 3 mois',
      revenue: '+950€/mois'
    },
    {
      name: 'Carlos',
      restaurant: 'El Taco Loco',
      quote: 'Incroyable ! VirtualEat a créé des marques qui correspondent parfaitement à ma cuisine. Résultat : +250 commandes par mois !',
      rating: 4.5,
      stats: '+250 commandes supplémentaires par mois',
      revenue: '+1,100€/mois'
    },
    {
      name: 'Fatima',
      restaurant: 'Délices du Maroc',
      quote: 'Mes ventes ont augmenté de 35% grâce aux marques virtuelles. L\'équipe VirtualEat gère tout, c\'est parfait !',
      rating: 4,
      stats: '+35% d\'augmentation des ventes',
      revenue: '+750€/mois'
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Logos des plateformes */}
        <div className="text-center mb-12">
          <p className="text-gray-600 font-semibold mb-6">Nos clients utilisent VirtualEat sur :</p>
          <div className="flex justify-center items-center gap-8 flex-wrap">
            <img 
              src="https://static.readdy.ai/image/a343775702a04f57d19e2d80438d20f8/5bf130391ed6bd3111354f4f2ad640e2.png"
              alt="Uber Eats"
              className="h-12 object-contain opacity-70 hover:opacity-100 transition-opacity"
            />
            <img 
              src="https://static.readdy.ai/image/a343775702a04f57d19e2d80438d20f8/35956f4f4d3d7d170ad0681dfb720bcf.png"
              alt="Deliveroo"
              className="h-12 object-contain opacity-70 hover:opacity-100 transition-opacity"
            />
            <div className="h-12 flex items-center">
              <span className="text-2xl font-bold text-orange-500">Just Eat</span>
            </div>
          </div>
        </div>

        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Ils ont fait confiance à <span className="text-[#9EFD38]">VirtualEat</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Découvrez comment nos clients ont transformé leur business
          </p>
        </div>

        {/* Cas client mis en avant */}
        <div className="bg-gradient-to-r from-[#9EFD38] to-[#7ED832] p-8 rounded-3xl mb-16 max-w-6xl mx-auto">
          <div className="text-center">
            <div className="bg-black/10 rounded-2xl p-2 mb-4 inline-block">
              <span className="text-black font-bold text-sm px-3 py-1">📊 CAS CLIENT</span>
            </div>
            <h3 className="text-3xl font-bold text-black mb-6">
              Snack Istanbul : +37% en 2 mois
            </h3>
            <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <div className="flex flex-col items-center">
                <i className="ri-arrow-up-line text-4xl text-black mb-2"></i>
                <span className="font-bold text-2xl text-black">+220</span>
                <span className="font-semibold text-black">commandes supplémentaires par mois</span>
              </div>
              <div className="flex flex-col items-center">
                <i className="ri-money-euro-circle-line text-4xl text-black mb-2"></i>
                <span className="font-bold text-2xl text-black">+1,450€</span>
                <span className="font-semibold text-black">de revenus mensuels supplémentaires</span>
              </div>
              <div className="flex flex-col items-center">
                <i className="ri-time-line text-4xl text-black mb-2"></i>
                <span className="font-bold text-2xl text-black">2 mois</span>
                <span className="font-semibold text-black">pour obtenir ces résultats</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 p-8 rounded-2xl hover:shadow-xl transition-shadow duration-300 relative">
              {/* Badge spécial pour les meilleurs résultats */}
              {(index === 0 || index === 2) && (
                <div className="absolute -top-3 -right-3 bg-red-500 text-white px-3 py-1 rounded-full text-xs font-bold">
                  ⭐ TOP RÉSULTATS
                </div>
              )}
              
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-[#9EFD38] rounded-full flex items-center justify-center mr-4">
                  <span className="text-2xl font-bold text-black">{testimonial.name.charAt(0)}</span>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-[#9EFD38] font-semibold">{testimonial.restaurant}</p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {[...Array(Math.floor(testimonial.rating))].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
                {testimonial.rating % 1 !== 0 && (
                  <i className="ri-star-half-fill text-yellow-400 text-lg"></i>
                )}
                {[...Array(5 - Math.ceil(testimonial.rating))].map((_, i) => (
                  <i key={i} className="ri-star-line text-gray-300 text-lg"></i>
                ))}
              </div>
              
              <blockquote className="text-gray-700 italic leading-relaxed mb-4">
                "{testimonial.quote}"
              </blockquote>

              {/* Statistiques concrètes */}
              <div className="border-t border-gray-200 pt-4 space-y-2">
                <div className="bg-green-100 text-green-800 px-3 py-2 rounded-lg text-sm font-semibold">
                  📈 {testimonial.stats}
                </div>
                <div className="bg-blue-100 text-blue-800 px-3 py-2 rounded-lg text-sm font-semibold">
                  💰 {testimonial.revenue}
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-[#9EFD38] to-[#7ED832] p-8 rounded-2xl max-w-4xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold text-black mb-4">
              Rejoignez plus de +50 restaurants qui ont choisi VirtualEat
            </h3>
            <div className="grid md:grid-cols-3 gap-6 mb-4">
              <div>
                <div className="text-3xl font-bold text-black">+37%</div>
                <p className="text-black font-semibold">Augmentation moyenne des ventes</p>
              </div>
              <div>
                <div className="text-3xl font-bold text-black">+1,200€</div>
                <p className="text-black font-semibold">Revenus supplémentaires/mois</p>
              </div>
              <div>
                <div className="text-3xl font-bold text-black">100%</div>
                <p className="text-black font-semibold">Clients satisfaits</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
